import { render, staticRenderFns } from "./Pinjaman.vue?vue&type=template&id=5b887707"
import script from "./Pinjaman.vue?vue&type=script&lang=js"
export * from "./Pinjaman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports